import { render, staticRenderFns } from "./muokkaa-teoriakoulutusta.vue?vue&type=template&id=7204de8d&scoped=true&"
import script from "./muokkaa-teoriakoulutusta.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-teoriakoulutusta.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-teoriakoulutusta.vue?vue&type=style&index=0&id=7204de8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7204de8d",
  null
  
)

export default component.exports